export const RACAS_CORES = [
  "Amarela",
  "Branca",
  "Indígena",
  "Parda",
  "Preta",
  "Não declarada",
];
